import React, { useEffect, useState } from "react";
import { useNavigate, useSearchParams } from "react-router-dom";
import { useCart } from "../context/CartContext";
import { verifySession } from "../services/api";
import { FiCheckCircle, FiPackage } from "react-icons/fi";
import "./Success.css";

const Success = () => {
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const { clearCart } = useCart();
  const sessionId = searchParams.get("session_id");

  const [loading, setLoading] = useState(true);
  const [orderData, setOrderData] = useState(null);
  const [error, setError] = useState(null);
  const [hasVerified, setHasVerified] = useState(false);

  useEffect(() => {
    if (sessionId && !hasVerified) {
      setHasVerified(true);
      clearCart();

      // Vérifier la session et récupérer les détails de la commande
      verifySession(sessionId)
        .then((response) => {
          if (response.data.success) {
            setOrderData(response.data);
          } else {
            setError("Impossible de vérifier le paiement");
          }
        })
        .catch((err) => {
          if (process.env.NODE_ENV === 'development') console.error("Erreur:", err);
          setError("Une erreur s'est produite");
        })
        .finally(() => {
          setLoading(false);
        });
    } else if (!sessionId) {
      setLoading(false);
      setError("Session invalide");
    }
  }, [sessionId, hasVerified, clearCart]);

  // Fonction pour télécharger manuellement la facture et tracker
  const handleManualDownload = async () => {
    if (!orderData?.orderNumber || !orderData?.order?.email) return;
    
    try {
      // Tracker le téléchargement
      await fetch(`${process.env.REACT_APP_API_URL || "http://localhost:5000/api"}/invoices/track-download`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify({
          orderNumber: orderData.orderNumber,
          email: orderData.order.email
        })
      });
    } catch (error) {
      // Ne pas bloquer l'UX si le tracking échoue
    }
    
    // Ouvrir la facture dans un nouvel onglet
    const invoiceUrl = `${
      process.env.REACT_APP_API_URL || "http://localhost:5000/api"
    }/invoices/${orderData.orderNumber}?email=${encodeURIComponent(
      orderData.order.email
    )}`;
    window.open(invoiceUrl, '_blank');
  };

  if (loading) {
    return (
      <div className="success-page">
        <div className="success-content">
          <div className="loading">Vérification du paiement...</div>
        </div>
      </div>
    );
  }

  if (error) {
    return (
      <div className="success-page">
        <div className="success-content">
          <p className="error-message">{error}</p>
        </div>
      </div>
    );
  }

  return (
    <div className="success-page">
      <div className="success-content">
        <FiCheckCircle className="success-icon" />
        <h1>Commande confirmée !</h1>

        {orderData?.orderNumber && (
          <div className="order-info">
            <FiPackage className="order-icon" />
            <p className="order-number">
              Numéro de commande : <strong>{orderData.orderNumber}</strong>
            </p>
            {orderData.order?.deliveryMethod === "pickup" &&
              orderData.order?.pickupLocation && (
                <p className="delivery-info">
                  🏪 Retrait en boutique :{" "}
                  <strong>{orderData.order.pickupLocation}</strong>
                </p>
              )}
            
            {/* Bouton de téléchargement manuel */}
            {orderData.orderNumber && orderData.order?.email && (
              <div className="invoice-download">
                <button
                  onClick={handleManualDownload}
                  className="btn-download-invoice"
                >
                  📄 Télécharger la facture (PDF)
                </button>
              </div>
            )}
          </div>
        )}

        <p className="success-message">
          {orderData?.order?.deliveryMethod === "pickup"
            ? `Merci pour votre achat chez Personal Regrets ! Votre commande sera prête sous 2-3 jours ouvrés.`
            : "Merci pour votre achat chez Personal Regrets ! Votre colis sera expédié sous 2-3 jours ouvrés."}
        </p>

        <div className="success-actions">
          <button className="btn btn-primary" onClick={() => navigate("/")}>
            Retour à l'accueil
          </button>
          <button
            className="btn btn-secondary"
            onClick={() => navigate("/shop")}
          >
            Continuer mes achats
          </button>
        </div>
      </div>
    </div>
  );
};

export default Success;
